import PropTypes from 'prop-types'

import ScreenContainer from 'components/ScreenContainer'
import { STRING } from 'resources'

import { Container, Content, Title, AccentText } from './styles'

const JackpotScreenHeader = ({ isFetching, currentPrize, numPrizes }) => (
  <Container>
    <Content>
      <ScreenContainer>
        <Title>
          {!isFetching &&
            (numPrizes > 1 ? (
              <>
                {STRING.jackpot.multiPrize(numPrizes)}
                <AccentText>{`$${currentPrize}`}</AccentText>
              </>
            ) : (
              <>
                {STRING.jackpot.currentPrize}
                <AccentText>{`$${currentPrize}`}</AccentText>
              </>
            ))}
        </Title>
      </ScreenContainer>
    </Content>
  </Container>
)

JackpotScreenHeader.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  currentPrize: PropTypes.string.isRequired,
  numPrizes: PropTypes.number.isRequired,
}

export default JackpotScreenHeader
